var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallbus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,16.9c-0.5,0-1-0.4-1-1c0-0.3,0-0.5,0-0.8C1,12.4,1,9.7,1,7c0-0.7,0.4-1.2,1.2-1.2c6,0,12,0,18,0 c1.2,0,2,0.6,2.1,1.8c0.2,1.5,0.5,2.9,0.6,4.4c0.1,0.9,0,1.8,0,2.6c0,0.4,0,0.8,0,1.1c0,0.5-0.4,1-1,1c-0.3,0-0.7,0-1,0 c0.1-1.1-0.2-2.1-1.2-2.6c-0.9-0.5-1.8-0.5-2.6,0c-0.9,0.6-1.2,1.5-1.1,2.5c-3,0-6,0-9,0c0.1-1-0.1-1.8-0.9-2.4 c-0.5-0.4-1.1-0.6-1.8-0.5C3.1,14,1.8,15.1,2,16.9z M22,12.4c0-0.3,0-0.6-0.1-0.8c-0.2-1.2-0.4-2.4-0.6-3.7c-0.1-0.6-0.4-1-1.1-1 c-1,0-2,0-2.9,0c-0.1,0-0.1,0-0.2,0C17,7,17,7,17,7c0,1.3,0,2.5,0,3.8c0,0.1,0,0.2,0.1,0.2c0.4,0.4,0.8,0.8,1.3,1.3 c0.1,0.1,0.2,0.1,0.3,0.1c1,0,2.1,0,3,0C21.8,12.4,21.9,12.4,22,12.4z M7,6.9c0,1.3,0,2.6,0,4c1.3,0,2.6,0,4,0c0-1.3,0-2.6,0-4 C9.6,6.9,8.3,6.9,7,6.9z M16,6.9c-1.3,0-2.6,0-4,0c0,1.3,0,2.6,0,4c1.3,0,2.6,0,4,0C16,9.6,16,8.3,16,6.9z M2,10.9c1.3,0,2.6,0,4,0 c0-1.3,0-2.6,0-4c0,0-0.1,0-0.1,0c-1.1,0-2.2,0-3.4,0C2.2,6.9,2,7.1,2,7.5c0,0.3,0,0.6,0,0.9C2,9.2,2,10,2,10.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.8,16.4c0-1,0.8-1.8,1.7-1.8c1,0,1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8C3.5,18.1,2.8,17.4,2.8,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.7,16.4c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8C17.5,18.1,16.7,17.4,16.7,16.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallbus);
export default __webpack_public_path__ + "static/media/smallbus.b8a26b0945cd7248a2259f970e18b47e.svg";
export { ForwardRef as ReactComponent };